import {createElement, Component, PropTypes} from 'rlink-react';
import {connect} from 'react-redux';
import pathForRouteInfo from 'rlink-router/pathForRouteInfo';
import navTo from 'rlink-router/actions/navTo';
import externalNavTo from 'rlink-router/actions/externalNavTo';
import openModal from 'rlink-router/actions/openModal';
import openFlyout from 'rlink-router/actions/openFlyout';
import BuildContext from 'rlink-router/BuildContext';
import getCurrentLocale from 'rlink-router/getCurrentLocale';
import getCurrentRegion from 'rlink-router/getCurrentRegion';
import { targetEnum } from 'rlink-router/constants';

const targetMap = new Map([[targetEnum.new, '_blank'], [targetEnum.self, '_self']]);

class Link extends Component {
  render () {
    let {
      onActivate,
      children,
      onClick,
      navState,
      targetType,
      target,
      ...props} = this.props;
    return <a
      onClick={ev => {
        let onClickHandlerPreventedDefault = false;
        if (onClick) {
          onClick(ev);
          onClickHandlerPreventedDefault = ev.defaultPrevented;
        }
        ev.preventDefault();
        if (onActivate && !onClickHandlerPreventedDefault) {
          onActivate(this.context.buildContext, navState);
        }
      }}
      target={targetType ? targetMap.get(targetType) : target}
      {...props}>{children}</a>;
  }
}

Link.propTypes = {
  download: PropTypes.string,
  href: PropTypes.string.isRequired,
  hreflang: PropTypes.string,
  media: PropTypes.string,
  ping: PropTypes.string,
  referrer: PropTypes.string,
  rel: PropTypes.string,
  target: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string,
  style: PropTypes.string,
  tabindex: PropTypes.number,
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  navState: PropTypes.shape({
    view: PropTypes.string.isRequired,
    params: PropTypes.objectOf(PropTypes.string),
    transition: PropTypes.string,
    returnTransition: PropTypes.string,
    scrollTo: PropTypes.shape({
      top: PropTypes.number,
      left: PropTypes.number,
    }),
  }),
  onActivate: PropTypes.func,
  onClick: PropTypes.func,
};

Link.contextTypes = {
  buildContext: PropTypes.instanceOf(BuildContext),
};

const NavLink = connect(
  ({routing}, {href}) => {
    let defaultLocParams = {
      locale: getCurrentLocale(routing),
      region: getCurrentRegion(routing),
    };
    if (typeof (href) === 'string') {
      return {};
    }
    return {
      href: pathForRouteInfo(routing, href.view, Object.assign(defaultLocParams, href.params || {})),
      navState: href,
    };
  },
  (dispatch, ownProps) => {
    let onActivate = (...args) => dispatch(navTo(...args));

    if (typeof (ownProps.href) === 'string') {
      onActivate = () => dispatch(externalNavTo({
        url: ownProps.href,
        targetType: ownProps.targetType,
      }));
      return {
        onActivate,
      };
    }

    if ('modal' in ownProps.href && ownProps.href.modal === true) {
      onActivate = (buildContext, navState) =>
        dispatch(openModal({buildContext, ...navState}));
    } else if ('flyout' in ownProps.href && ownProps.href.flyout === true) {
      onActivate = (buildContext, navState) =>
        dispatch(openFlyout({buildContext, ...navState}));
    }
    return {onActivate};
  },
  null,
  {
    getDisplayName () {
      return 'NavLink';
    },
  }
)(Link);

NavLink.propTypes = Object.assign({}, Link.propTypes, {
  href: PropTypes.oneOfType([PropTypes.shape({
    view: PropTypes.string.isRequired,
    params: PropTypes.objectOf(PropTypes.string),
    transition: PropTypes.string,
    returnTransition: PropTypes.string,
    scrollTo: PropTypes.shape({
      top: PropTypes.number,
      left: PropTypes.number,
    }),
    keepScrollPosition: PropTypes.bool,
    modal: PropTypes.boolean,
    flyout: PropTypes.boolean,
  }), PropTypes.string]).isRequired,
  targetType: PropTypes.oneOf(Object.values(targetEnum)),
});

export default NavLink;



// WEBPACK FOOTER //
// ./lib/rlink-router/NavLink.jsx